import React, { useState } from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import { Stack } from '../../../atoms/stack/Stack';
import { Row } from '../../../atoms/row/Row';
import { Checkbox } from '../../../atoms/checkbox/Checkbox';

const HeaderCard = ({
  title,
  description,
  options,
  action,
  selectedOption,
  setSelectedOption,
  texts,
  t,
}) => {
  const [validationError, setValidationError] = useState(false);
  const hasError = validationError && !selectedOption;

  const handleOptionChange = (value) => {
    setSelectedOption(value);
    setValidationError(false);
  };

  const handleButtonClick = () => {
    if (!selectedOption) {
      setValidationError(true);
    } else {
      setValidationError(false);
      action();
    }
  };

  return (
    <Stack className="box-border bg-white px-5 py-5 sm:py-10 rounded-3xl border-primary-800 border-8 gap-3 items-center max-md:mb-5">
      <Stack>
        <Typography as="p" fontVariant="h6">
          {title}
        </Typography>
        <Typography
          fontVariant="md"
          className="!text-customGray-600 w-[250px] sm:w-[280px]"
        >
          {`(${description})`}
        </Typography>
      </Stack>
      <Row className="w-full justify-between px-4 my-2">
        {options.map((size) => (
          <label
            key={size}
            htmlFor={size}
            className="flex flex-col items-center cursor-pointer"
          >
            <Typography as="span" fontVariant="sm" className="font-medium">
              {size}
            </Typography>
            <Checkbox
              className={hasError ? 'border-2' : ''}
              id={size}
              value={size}
              checked={selectedOption === size}
              onChange={() => handleOptionChange(size)}
              error={hasError}
            />
          </label>
        ))}
      </Row>

      {hasError && (
        <Typography className="!text-red-500 font-medium" fontVariant="lg">
          {t('guideHome.formCompanySizeError')}
        </Typography>
      )}

      {texts.map((text) => (
        <Typography
          key={text}
          fontVariant="md"
          className="max-w-80 !text-customGray-600"
        >
          {t(text)}
        </Typography>
      ))}
      <button
        type="button"
        className="bg-primary-700 uppercase rounded-[48px] text-white text-clamp-md mt-3 px-6 py-3 font-medium w-fit global-hover"
        onClick={handleButtonClick}
      >
        {t('guideHome.startGuide')}
      </button>
    </Stack>
  );
};

export default HeaderCard;
